<template>
  <div class="cascader-address">
    <el-select
      filterable
      v-model="province"
      placeholder="请选择"
      @change="provinceChange"
      :disabled="disabled"
    >
      <el-option v-if="showAll" label="全部" value></el-option>
      <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select
      filterable
      v-model="city"
      placeholder="请选择"
      class="select"
      @change="cityChange"
      :disabled="disabled"
    >
      <el-option v-if="showAll" label="全部" value></el-option>
      <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select
      filterable
      v-model="area"
      placeholder="请选择"
      class="select"
      @change="syncValues"
      :disabled="disabled"
      v-if="!(type=== 'list')"
    >
      <el-option v-if="showAll" label="全部" value></el-option>
      <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: "cascader-address",
  props: [
    "showAll",
    "disabled",
    "provinceId",
    "cityId",
    "areaId",
    "provinceName",
    "cityName",
    "ywCityId",
    "areaName",
    "value",
    "type"
  ],
  data() {
    return {
      province: "",
      city: "",
      area: "",
      provinces: [],
      cities: [],
      areas: []
    };
  },
  mounted() {
    if (this.$props.value) {
      if (this.value.length === 0) {
        this.$watch("value", this.initValue);
      } else {
        this.initValue();
      }
    } else {
      this.init();
    }
  },
  methods: {
    init() {
      this.loadData(0, "provinces");
    },
    async initValue(newVal, oldVal) {
      const [provinceId, cityId, areaId] = this.value;
      if (provinceId || provinceId === 0 || provinceId === "") {
        await this.loadData(0, "provinces");
        this.province = provinceId;
        if (!this.findAtById(this.provinces, this.province)) {
          this.province = "";
        }
      }

      if (cityId || cityId === 0) {
        if (provinceId) {
          await this.loadData(provinceId, "cities");
        }
        this.city = cityId;
        if (!this.findAtById(this.cities, this.city)) {
          this.city = "";
        }
      }

      if (areaId || areaId === 0) {
        if (cityId) {
          await this.loadData(cityId, "areas");
        }
        this.area = areaId;
        if (!this.findAtById(this.areas, this.area)) {
          this.area = "";
        }
      }
      this.syncValues();
    },
    async loadData(parentId, type) {
      // 加载第一级列表
      const { ret, data } = await _api.customer.getDistrictList({
        parentId,
        v: Math.random()
      });
      if (ret && data) {
        this[type] = data;
        switch (type) {
          case "provinces":
            this.province = "";
            this.city = "";
            this.area = "";
            this.cities = [];
            this.areas = [];
            break;
          case "cities":
            this.city = "";
            this.area = "";
            this.areas = [];
            break;

          case "areas":
            this.area = "";
            break;
          default:
            break;
        }
      }
    },
    syncValues() {
      this.$emit("update:provinceId", this.province);
      this.$emit("update:cityId", this.city);
      this.$emit("update:areaId", this.area);

      const { name: ptext = "" } = this.findAtById(this.provinces, this.province) || {};
      const { name: ctext = "" , cityId: ywCityId} = this.findAtById(this.cities, this.city) || {};
      const { name: atext = "" } = this.findAtById(this.areas, this.area) || {};

      this.$emit("update:provinceName", ptext);
      this.$emit("update:cityName", ctext);
      this.$emit("update:ywCityId", ywCityId);
      this.$emit("update:areaName", atext);

      this.$emit("update:text", [ptext, ctext, atext]);
    },
    provinceChange(parentId) {
      this.loadData(parentId, "cities");
      this.syncValues();
    },
    cityChange(parentId) {
      this.loadData(parentId, "areas");
      this.syncValues();
    },
    reset() {
      this.province = "";
      this.city = "";
      this.area = "";
      this.cities = [];
      this.areas = [];
      this.syncValues();
    },
    findAtById(options, id) {
      return options.find(el => el.id === id);
    }
  }
};
</script>

<style>
.select {
  margin-left: 9px;
}
.cascader-address .el-select {
  width: 94px;
}
.cascader-address .el-select > .el-input {
  width: 94px;
}
</style>
